import { render, staticRenderFns } from "./description.vue?vue&type=template&id=4e3ec87a&scoped=true&"
import script from "./description.vue?vue&type=script&lang=js&"
export * from "./description.vue?vue&type=script&lang=js&"
import style0 from "./description.vue?vue&type=style&index=0&id=4e3ec87a&lang=scss&scoped=true&"
import style1 from "./description.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ec87a",
  null
  
)

export default component.exports